var _linearGradient, _circle, _rect, _linearGradient2, _rect2, _linearGradient3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNextjsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NRNx2IPDe7PJlJvrxOKgWa",
    x1: 24,
    x2: 24,
    y1: 43.734,
    y2: 4.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a070a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4b4b"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 19.734,
    fill: "url(#NRNx2IPDe7PJlJvrxOKgWa)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.023,
    height: 15.996,
    x: 15.992,
    y: 16.027,
    fill: "#fff"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NRNx2IPDe7PJlJvrxOKgWb",
    x1: 30.512,
    x2: 30.512,
    y1: 33.021,
    y2: 18.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988,
    stopColor: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.953,
    height: 14.59,
    x: 29.035,
    y: 15.957,
    fill: "url(#NRNx2IPDe7PJlJvrxOKgWb)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "NRNx2IPDe7PJlJvrxOKgWc",
    x1: 22.102,
    x2: 36.661,
    y1: 21.443,
    y2: 40.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#NRNx2IPDe7PJlJvrxOKgWc)",
    points: "36.781,38.094 34.168,39.09 15.992,16.027 19.508,16.027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjsIcon);
export default __webpack_public_path__ + "static/media/nextjsIcon.5ff4f0c94f10fa28bd94d5945ca4b7f7.svg";
export { ForwardRef as ReactComponent };